import { AVATAR_SIZES, AvatarSize } from '../constants';

const safelyParse = (name: string) => {
  try {
    const unicodeInitialsRegex = new RegExp(
      /(?:^|\s|-)+([^\s-])[^\s-]*(?:(?:\s+)(?:the\s+)?(?:jr|sr|II|2nd|III|3rd|IV|4th|\(.*\))\.?$)?/gi,
    );

    const initials = name
      .replace(unicodeInitialsRegex, '$1')
      .toUpperCase()
      .trim();

    if (initials.length > 1) {
      return [initials.charAt(0), initials.charAt(initials.length - 1)];
    } else {
      return [initials.charAt(0)];
    }
  } catch (e) {
    // This regex gets initials for the english alphabet and is supported in all browsers.
    // We will fallback to this when the user is on an outdated browser version.
    const englishAlphabetNames = new RegExp(/\b\w/g);
    return name.match(englishAlphabetNames) ?? [name.trimStart().charAt(0)];
  }
};

export default function initialsFromName(name?: string, size?: AvatarSize) {
  if (!name) return null;

  const initials = safelyParse(name);
  if (initials?.length === 0) return null;

  // SMALL_16 has only one letter
  if (size === AVATAR_SIZES.SMALL_16) {
    return (initials.shift() ?? '').toUpperCase();
  }

  return ((initials.shift() ?? '') + (initials.pop() ?? '')).toUpperCase();
}
